module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-ranking"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.joinedGroup),
      expression: "joinedGroup"
    }],
    staticClass: "list"
  }, [_c('ranking-list', {
    attrs: {
      "items": _vm.leaderboards
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in-up",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "current-ranking"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('webp-image', {
    attrs: {
      "src": _vm.myGroup.icon,
      "alt": "logo",
      "width": "100%",
      "height": "100%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.myGroup.name)), _c('br'), _c('small', [_vm._v("第 " + _vm._s(_vm.myGroup.ranking) + " 名")])]), _vm._v(" "), _c('div', {
    staticClass: "course"
  }, [_vm._v(_vm._s(_vm.duration2course(_vm.myGroup.duration)))]), _vm._v("节\n      ")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.joinedGroup),
      expression: "!joinedGroup"
    }],
    staticClass: "joinin"
  }, [_c('webp-image', {
    staticClass: "image",
    attrs: {
      "src": "https://cdn.llscdn.com/fe-static/lls-with-tfchina/school-VO6WsvMr.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("加入高校战队")]), _vm._v(" "), _c('p', [_vm._v("除了自己捐课，你还可以加入自己喜欢的高校战队，为它助力。")]), _vm._v(" "), _c('touch', {
    staticClass: "open-groups",
    attrs: {
      "tag": "button",
      "type": "button"
    },
    on: {
      "tap": _vm.gotoGroups
    }
  }, [_vm._v("加入高校战队")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("*加入高校战队不影响个人捐赠记录和排名哦~")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-53b66980","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupRanking.vue
// module id = 205
// module chunks = 1